import { render, staticRenderFns } from "./promoterModal.vue?vue&type=template&id=2b0fec12&"
import script from "./promoterModal.vue?vue&type=script&lang=js&"
export * from "./promoterModal.vue?vue&type=script&lang=js&"
import style0 from "./promoterModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports